import { breadCrumbValue } from "src/components/BreadCrumb/breadcrumb_generic";
import { App } from "src/interfaces/App";

export function getCategoryName(app: any): breadCrumbValue[] | undefined {
  try {
    const response = app as App;

    if (response.name === "NOT_FOUND") return undefined;

    return [
      {
        name: response.category?.name,
        link: response.category?.slug
          ? `/app/catalog/list/${response.category?.slug}`
          : undefined,
      },
      {
        name: response.name,
      },
    ];
  } catch (error) {
    return undefined;
  }
}
